import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CategoryModel, DefaultList, TableList } from '../../models'

export interface CategoryState {
    Category: CategoryModel
    CategoryList: TableList<CategoryModel>
}

const initialState: CategoryState = {
    Category: {} as CategoryModel,
    CategoryList: DefaultList,
}

export const CategorySlice = createSlice({
    name: 'category',
    initialState,
    reducers: {
        setCategories: (state, action: PayloadAction<CategoryModel[]>) => {
            state.CategoryList.items = action.payload
        },
        saveCategory: (state, action: PayloadAction<CategoryModel>) => {
            let category = action.payload
            if (category.Id > 0) {
                let defaultModel: CategoryModel = {
                    Id: category.Id,
                    CategoryName: category.CategoryName,
                }
                let currentCategory =
                    state.CategoryList.items.find((c) => c.Id === category.Id) || defaultModel
                currentCategory.CategoryName = category.CategoryName
            } else {
                category.Id = (Math.max(...state.CategoryList.items.map((c) => c.Id)) || 0) + 1
                state.CategoryList.items.push(category)
            }
        },
        getCategoryById: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let category: CategoryModel = {} as CategoryModel
            if (id > 0) {
                let currentCategories: CategoryModel[] = state.CategoryList.items
                category = currentCategories.find((c) => c.Id === id) || ({} as CategoryModel)
            }

            state.Category = category
        },
        deleteCategories: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentCategories: CategoryModel[] = state.CategoryList.items
                state.CategoryList.items = currentCategories.filter((c) => !ids.includes(c.Id))
            }
        },
    },
})

export const { setCategories, saveCategory, getCategoryById, deleteCategories } =
    CategorySlice.actions

export default CategorySlice.reducer
